<template>
    <div
        class="modal fade"
        :id="modalId"
        tabindex="-1"
        :aria-labelledby="ariaLabel ? ariaLabel : modalId + '-label'"
        :aria-hidden="hidden"
        role="dialog"
        @click="submitRequest"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content my-20 mx-auto drl-modal-content border-0 shadow-lg">

                <div class=" custom_modal__header modal-header border-0">
                    <h1 class="font-poppins font-size-30 color-blue font-weight-normal search-profile-title">
                        {{ title ? title : '' }}
                    </h1>
                    <img src="/img/employee-dashboard/person-with-book.svg" class="dlr-modal-image position-absolute">
                    <button type="button" class="close opacity-1" aria-label="Close" data-dismiss="modal" @click="submitRequest">
                        <img class="opacity-1 dlr-modal-close-button position-absolute"
                             src="/img/employee-dashboard/close.svg">
                    </button>
                </div>

                <div class="modal-body pr-md-5 mr-sm-1 pr-sm-0">
                    <slot name="content"></slot>
                </div>

                <div class="modal-footer d-block border-0 ">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {
        title: String,
        modalId: {
            type: String,
            required: true,
        },
        ariaLabel: {
            type: String,
            default: null
        },
        hidden: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        submitRequest() {
            this.$emit('submitRequest')
        }
    },
}
</script>
